import { AlertTriangle } from "lucide-react";
import { Bar, BarChart, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const COLOR_HEX = { W: "#F3EBC8", U: "#38BDF8", B: "#71717A", R: "#EF4444", G: "#22C55E", C: "#94A3B8" };
const tooltip = { contentStyle: { background: "#0F1A2E", border: "1px solid #2A3447", fontSize: 12 }, labelStyle: { color: "#E6D3A3" } };

export function DeckStats({ stats, warnings, legality }) {
  if (!stats) return null;
  return (
    <div className="space-y-5" data-testid="deck-stats">
      <div className="panel grid grid-cols-2 gap-3 p-4">
        <div><p className="eyebrow text-[10px]">Cards</p><p className="font-heading text-2xl text-amber-100" data-testid="deck-stat-size">{stats.deck_size}</p></div>
        <div><p className="eyebrow text-[10px]">Avg mana value</p><p className="font-heading text-2xl text-amber-100" data-testid="deck-stat-avg-mv">{stats.average_mana_value}</p></div>
      </div>
      <div className="panel p-4">
        <p className="eyebrow mb-3 text-[10px]">Mana curve (non-land)</p>
        <div className="h-36" data-testid="deck-stat-curve">
          <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1}><BarChart data={stats.mana_curve}><XAxis dataKey="mv" stroke="#64748B" fontSize={11} /><YAxis allowDecimals={false} stroke="#64748B" fontSize={11} width={24} /><Tooltip {...tooltip} cursor={{ fill: "rgba(34,211,238,0.06)" }} /><Bar dataKey="count" fill="#C7A257" radius={[3, 3, 0, 0]} /></BarChart></ResponsiveContainer>
        </div>
      </div>
      <div className="panel grid grid-cols-2 gap-3 p-4">
        <div>
          <p className="eyebrow mb-2 text-[10px]">Colors</p>
          {stats.color_distribution.length ? (
            <div className="h-28" data-testid="deck-stat-colors">
              <ResponsiveContainer width="100%" height="100%" minWidth={1} minHeight={1}><PieChart><Pie data={stats.color_distribution} dataKey="count" nameKey="color" innerRadius={22} outerRadius={44} stroke="#0F1A2E">
                {stats.color_distribution.map((c) => <Cell key={c.color} fill={COLOR_HEX[c.color]} />)}</Pie><Tooltip {...tooltip} /></PieChart></ResponsiveContainer>
            </div>
          ) : <p className="text-xs text-slate-600">—</p>}
        </div>
        <div>
          <p className="eyebrow mb-2 text-[10px]">Card types</p>
          <ul className="space-y-1 text-xs" data-testid="deck-stat-types">
            {stats.type_distribution.map((t) => <li key={t.type} className="flex justify-between text-slate-300"><span>{t.type}</span><span className="font-mono text-aether-300">{t.count}</span></li>)}
          </ul>
        </div>
      </div>
      {legality && (
        <div className="panel p-4" data-testid="deck-legality">
          <p className={`eyebrow mb-2 text-[10px] ${legality.legal ? "text-emerald-300" : "text-copper-300"}`} data-testid="deck-legality-status">
            Automated checks: {legality.legal ? "legal" : "not legal yet"}
          </p>
          {legality.manual_review?.length > 0 && (
            <><p className="mt-2 text-[11px] uppercase tracking-wider text-slate-500">Needs manual review</p>
              <ul className="mt-1 list-disc space-y-1 pl-4 text-xs text-slate-300" data-testid="deck-manual-review">{legality.manual_review.map((m) => <li key={m}>{m}</li>)}</ul></>
          )}
        </div>
      )}
      {warnings?.length > 0 && (
        <div className="panel border-copper-600/50 p-4" data-testid="deck-warnings">
          <p className="eyebrow mb-2 text-[10px] text-copper-300">Format checks</p>
          <ul className="space-y-1.5 text-xs text-copper-200">
            {warnings.map((w) => <li key={w} className="flex gap-1.5"><AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />{w}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
